import React from "react";
import { useNavigate } from "react-router-dom";

interface BrandTextProps {
  className?: string;
  as?: "h1" | "h2" | "h3" | "span" | "div";
  linkTo?: string | false;
}

export default function BrandText({ className = "", as = "span", linkTo = "/" }: BrandTextProps) {
  const navigate = useNavigate();
  const Component = as;

  const content = (
    <Component className={`font-bold brand-title-subtle-bold ${className}`}>
      <span className="text-brand-blue tracking-tight">Crea</span>
      <span className="text-brand-green tracking-tight font-black">Financia</span>
    </Component>
  );

  if (linkTo === false) return content;

  return (
    <button onClick={() => navigate(linkTo)} className="cursor-pointer focus:outline-none">
      {content}
    </button>
  );
}
